import dayjs from "dayjs";

const dash = (val) => val || "—";

const PRIORITY_STYLES = {
  high:    { color: "#dc2626", background: "#fef2f2", border: "1.5px solid #fecaca" },
  medium:  { color: "#b45309", background: "#fffbeb", border: "1.5px solid #fde68a" },
  low:     { color: "#0369a1", background: "#e0f2fe", border: "1.5px solid #bae6fd" },
  general: { color: "#6b7a99", background: "#f0f5fb", border: "1.5px solid #dde8f4" },
};

const PriorityBadge = ({ val }) => {
  if (!val) return "—";
  const key = val.toLowerCase();
  const s = PRIORITY_STYLES[key] || PRIORITY_STYLES.general;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      padding: "3px 10px", borderRadius: 8, fontSize: "0.75rem", fontWeight: 600,
      whiteSpace: "nowrap",
      color: s.color, background: s.background, border: s.border,
    }}>
      {val}
    </span>
  );
};

export const systemNoticeColumns = (actionCellRenderer) => [
  {
    title: "Priority",
    dataIndex: "priority",
    key: "priority",
    render: (val) => <PriorityBadge val={val} />,
  },
  { title: "Posting Header", dataIndex: "postingHeader", key: "postingHeader", render: dash },
  { title: "Post Type",      dataIndex: "postType",      key: "postType",      render: dash },
  { title: "Subject",        dataIndex: "subject",       key: "subject",       render: dash },
  {
    title: "Expiry Date",
    dataIndex: "expiryDate",
    key: "expiryDate",
    render: (dt) => dt ? dayjs(dt).format("YYYY-MMM-DD") : "—",
  },
  {
    title: "Actions",
    dataIndex: "",
    key: "actions",
    render: actionCellRenderer,
    width: 160,
  },
];
